import React from 'react';
import { AppDispatch, RootState, useDispatch, useSelector } from 'src/store';
import { asyncRequestRendering } from '../../reducers/RenderRequestSlice';

export const RenderButton = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { renderState } = useSelector((state: RootState) => state.renderRequest);
  const { cytoBandFile, bandFile, sampleFile } = useSelector((state: RootState) => state.buildRenderRequest);

  return (
    <button
      type="button"
      className="generate-btn"
      disabled={!sampleFile || !(cytoBandFile || bandFile) || renderState === 'running'}
      onClick={() => dispatch(asyncRequestRendering())}
    >
      {renderState === 'running' ? 'Rendering…' : 'Generate Ideogram'}
    </button>
  );
};
